module.exports = __webpack_public_path__ + "img/right-icon.a76c1b8d.svg";